import { Scene } from "phaser";
import { EVENTS_NAME, GameStatus } from "../../consts.ts";
import { Text } from "../../classes/text";

export class GameMainUIScene extends Scene {
  gameEndHandler: (status: GameStatus) => void;
  private gameEndPhrase!: Text;

  constructor() {
    super("GameMainUIScene");
    // Game conclusion
    this.gameEndHandler = (status) => {
      this.cameras.main.setBackgroundColor("rgba(0,0,0,0.6)");
      // NB game26 scene keys — the old "level-1-scene"/"Level1" keys were
      // game24 leftovers: scene.get("Level1") returned null and the restart
      // click threw, wedging the WASTED screen.
      this.game.scene.pause("GameMain");
      this.gameEndPhrase = new Text(
        this,
        this.game.scale.width / 2,
        this.game.scale.height * 0.4,
        status === GameStatus.LOSE
          ? `WASTED!\nCLICK TO RESTART`
          : `YOU ARE ROCK!\nCLICK TO RESTART`,
      )
        .setAlign("center")
        .setColor(status === GameStatus.LOSE ? "#ff0000" : "#ffffff");
      this.gameEndPhrase.setPosition(
        this.game.scale.width / 2 - this.gameEndPhrase.width / 2,
        this.game.scale.height * 0.4,
      );
      // restart on click
      this.input.once("pointerdown", () => {
        this.game.events.off(EVENTS_NAME.gameEnd, this.gameEndHandler);
        const gameMain = this.scene.get("GameMain");
        if (gameMain) {
          gameMain.scene.restart();
        }
        this.scene.restart();
      });
    };
    // Win condition
    // this.chestLootHandler = () => {
    //   this.hpViewer.changeValue(ScoreOperations.INCREASE, 10);
    //   if (this.hpViewer.getValue() === winScore) {
    //     this.game.events.emit(EVENTS_NAME.gameEnd, "win");
    //   }
    // };
  }

  create(): void {
    this.initListeners();
  }

  private initListeners(): void {
    this.game.events.on(EVENTS_NAME.gameEnd, this.gameEndHandler, this);
  }
}
